import { HttpClient } from '../../httpClient'
import { OpalApi } from '../../schema'

type UpdateCustomFieldV3 = OpalApi<'UpdateBlockCustomFieldValueV3', 200>

export const updateBlockCustomFieldValue: UpdateCustomFieldV3 = async (
  args = {}
) => {
  const customFieldValueId = args.params?.path.block_custom_field_value_id

  if (typeof customFieldValueId !== 'string') {
    throw new Error('Must supply a valid custom_field_id.')
  }

  const url = new URL(
    `loupe/v3/block_custom_field_values/${customFieldValueId}`,
    window.location.origin
  )

  return HttpClient()
    .patch(url.toString(), args.requestBody)
    .then((res) => res.data)
}
